module.exports = __webpack_public_path__ + "static/media/ted-bw2.b53e771d.png";